import { apiClient } from "api/ApiClient";

/**
 * message.propertiesから表示文言を取得
 */
const getCollectionRequestFormContents = async (): Promise<any> => {
    try {
        const response = await apiClient.get(`/display/collectionrequest`);
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
        return e;
    }
};

export const FormDisplayContentsApi = {
    getCollectionRequestFormContents,
};
